import React from 'react';
import is from 'is_js';
import BaseSessionNav from 'components/BaseSessionNav';
import PropTypes from 'prop-types';
import { connect } from 'omni-common-ui';
import { Map } from 'immutable';
import { getProgressTestPlanFromIndex } from 'data/ProgressTestsPlan/accessors';
import { actions as UiState } from 'data/UiState';
import { actions as Group } from 'containers/Group';
import { getMonthAbbr } from 'domain/Month';
import { getWeekdayAbbr } from 'domain/Weekday';

class ProgressTestSessionNavHFv4 extends BaseSessionNav {
  _hasNext() {
    return this.props.currentProgressTestIndex < this.props.progressTestCount - 1;
  }

  _hasPrevious() {
    return this.props.currentProgressTestIndex > 0;
  }

  _hasNextUnit() {
    return this.props.currentProgressTestIndex < this.props.progressTestCount - 1;
  }

  _hasPreviousUnit() {
    return this.props.currentProgressTestIndex > 0;
  }

  _getHeadingText() {
    const name = this.props.currentProgressTestName || '';
    if (name === 'Midterm Exam') return 'Midterm';
    if (name === 'Final Exam') return 'Final';
    return name;
  }

  _getPreviousUnitText() {
    return `< UNIT ${this.props.currentProgressTestIndex}`;
  }

  _getNextUnitText() {
    return `UNIT ${this.props.currentProgressTestIndex + 2} >`;
  }

  _getAdditionalChildren() {
    return this.props.currentProgressTestSessionTime;
  }

  render() {
    if (this.props.currentProgressTestId) {
      return super.render();
    }
    return null;
  }
}

ProgressTestSessionNavHFv4.propTypes = Object.assign({
  isSSV3Group: PropTypes.bool,
  currentGroupName: PropTypes.string,
  currentProgressTestName: PropTypes.string,
  currentProgressTestIndex: PropTypes.number.isRequired,
  currentProgressTestId: PropTypes.string,
  currentProgressTestSessionTime: PropTypes.string,
  progressTestCount: PropTypes.number.isRequired,
  onNextClicked: PropTypes.func,
  onPreviousClicked: PropTypes.func,
  getProgressTestPlanFromIndex: PropTypes.func,
  isUnitQuiz: PropTypes.bool.isRequired,
}, BaseSessionNav.propTypes);

function mapStateToProps(state, ownProps) {
  const { groupId, progressTestIndex } = ownProps.params;
  if (! progressTestIndex) return;
  const { buildRoute, routes, isUnitQuiz } = ownProps;
  const group = state.get('rootReducer').get('groups').get(groupId) &&
    state.get('rootReducer').get('groups').get(groupId).data;
  const progressTestsPlans = state.get('rootReducer').get('progressTestsPlan').get(groupId);
  const progressTestsPlan = progressTestsPlans &&
    progressTestsPlans.data &&
    progressTestsPlans.data.filter((ptp) => ptp.isUnitQuiz === isUnitQuiz);
  const currentProgressTestPlan =
    getProgressTestPlanFromIndex(state, groupId, progressTestIndex, isUnitQuiz);
  if (group && progressTestsPlan) {
    const currentRoute = routes[routes.length - 1];
    const progressTestId = currentProgressTestPlan.id;
    const progressTests = state.get('rootReducer').get('progressTests');
    const progressTest = Map.isMap(progressTests) && progressTests.get(progressTestId);
    const sessionDateTimeUtc = progressTest && progressTest.data &&
      progressTest.data.progressTestSession &&
      progressTest.data.progressTestSession.get('sessionDateTimeUtc');

    return {
      isSSV3Group: !! Group.isSSV3Group(state, groupId),
      currentProgressTestId: progressTestId,
      currentProgressTestName: currentProgressTestPlan.name,
      currentProgressTestSessionTime: formatSessionDate(sessionDateTimeUtc),
      currentGroupName: group.name,
      progressTestCount: progressTestsPlan.size,
      currentProgressTestIndex: progressTestIndex,
      nextSessionLinkHref: getNextProgressTestLinkHref(progressTestIndex, currentRoute, buildRoute),
      previousSessionLinkHref: getNextProgressTestLinkHref(progressTestIndex,
        currentRoute,
        buildRoute,
        true),
      isHide: ! UiState.getShowNavigationBar(state),
    };
  }
}

function formatSessionDate(dateStr) {
  if (! dateStr) return '';
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return '';
  return `${getWeekdayAbbr(d.getDay())}, ${d.getDate()} ${getMonthAbbr(d.getMonth())} ${d.getFullYear()}`;
}

function getNextProgressTestLinkHref(index, currentRoute, buildRoute, previous = false) {
  const progressTestIndex = Number.parseInt(index, 10) + (previous ? - 1 : 1);
  const { sessionNavConfig } = currentRoute;
  const newRouteParams = {
    progressTestIndex,
  };
  if (is.object(sessionNavConfig) && is.string(sessionNavConfig.setModeOnNavigate)) {
    newRouteParams.mode = sessionNavConfig.setModeOnNavigate;
  }
  const tempRoute = buildRoute(newRouteParams);
  return buildRoute(`${tempRoute}`);
}

export default connect(mapStateToProps, null)(ProgressTestSessionNavHFv4);



// WEBPACK FOOTER //
// ./containers/Group/MidtermAndFinalExamHFv4/ProgressTestSessionNavHFv4/index.jsx